import { useSession } from "components/auth/hooks/SessionContext";
import HeaderLink from "./components/HeaderLink";
import Feature from "components/Feature";
import Login from "components/auth/Login";
import Logout from "components/auth/Logout";
import {
  innerHeaderStyle,
  headerPipeStyle,
  logoImageStyle,
  logoLinkStyle,
  productNameStyle,
  rightAligned
} from "./styles";
import { Stack, Text } from "@fluentui/react";
import { DOCS_URL } from "utils/constants";


export const HeaderBar: React.FC = () => {
  
  return (
    <Stack
      className={innerHeaderStyle}
      horizontal
      wrap
      verticalAlign="center"
      tokens={headerTokens}
      style={{"height": "32px"}}
    >
      <a
        className={logoLinkStyle}
        href="https://destination-earth.eu"
        aria-label="Destination Earth"  
      >
        <img
            alt=""
            className={logoImageStyle}
            src="./images/destination_earth_logo_W.svg"
            role="presentation"
            aria-hidden="true"
          />
      </a>
      <div className={headerPipeStyle}>|</div>
      <HeaderLink isNav to="/">
        <Text block variant="large" className={productNameStyle}>
          Data Lake
        </Text>
      </HeaderLink>
      {/* <HeaderLink isNav to="/explore">
        Explore
      </HeaderLink> */}
      <HeaderLink isNav to="/catalog">
        DestinE Data Portfolio
      </HeaderLink>
      <HeaderLink external to={DOCS_URL}>
        Documentation
      </HeaderLink>
      <HeaderLink isNav to="/services">
        Edge Services
      </HeaderLink>

      <div className={rightAligned}>

        <Stack horizontal verticalAlign="center" tokens={authSectionTokens}>
          <div style={{
            width: "0px",
            height: "23.5px",
            backgroundColor: `rgb(138, 136, 134)`,
            marginLeft: "14px",
            marginRight: "14px"
          }}>
          </div>
          <Feature name="login">
            <Login />
            <Logout />
          </Feature>

        </Stack>
      </div>
    </Stack>
  );
};

const headerTokens = { childrenGap: "10px 21px" };
const authSectionTokens = { childrenGap: 4 };
